import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initialiseAuth } from './auth/msal';
// The stylesheet block. Append-only, and the order is the cascade: tokens
// first because everything below reads them, then the shell's primitives, then
// one file per surface area. CLM-37's four go last — they reuse .card, .tag,
// .btn and .vh and add nothing that the shell or the planner would want to
// override.
import './styles/tokens.css';
import './styles/shell.css';
import './styles/ingest.css';
import './styles/upload.css';
import './styles/table.css';
import './styles/verify.css';
import './styles/record.css';
import './styles/search.css';
import './styles/upload-bundle.css';
import './styles/clauses.css';
import './styles/quality.css';
import './styles/search-quality.css';
import './styles/search-aliases.css';
import './styles/reconcile.css';
import './styles/match-review.css';
import './styles/party-picker.css';
import './styles/selection.css';
import './styles/pipeline.css';
import './styles/tags.css';
import './styles/analytics.css';
import './styles/vendor-import.css';

/**
 * Entry point.
 *
 * MSAL is initialised and any in-flight redirect settled *before* React mounts.
 * Rendering first produces a visible flash of the signed-out state on every
 * return from Entra, and MsalProvider assumes an initialised instance.
 */

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing #root');
}

const root = createRoot(container);

function renderFatal(error: unknown): void {
  const message = error instanceof Error ? error.message : String(error);
  root.render(
    <div className="centre">
      <h1>CLM could not start</h1>
      <p className="mut">{message}</p>
    </div>,
  );
}

void initialiseAuth().then(
  () => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  },
  (error: unknown) => {
    renderFatal(error);
  },
);
